/**
 * UI elements
 */
class PawAug_UI {
    constructor() {
        this.init3dViewer();
        this.textureRatioW = 15;
        this.textureRatioH = 10;
        this.texturePath = '';
        this.materialIndex = 0;
        
        setTimeout(() => {
            this.initSmoothScroll();
            this.initProductDemo();
            this.initCustomPhotoPopup();
            this.initCustomProductPopup();
            this.initAddToCartButtonsForPhotos();
            this.initNewestInfoBlock();

            if (
                document.body.classList.contains('postid-6370') ||
                document.body.classList.contains('postid-6397') ||
                document.body.classList.contains('postid-6362') ||
                document.body.classList.contains('postid-6366')
            ) {
                this.createStylizedOptionSelector('pa_rozmiar');
                this.createStylizedOptionSelector('pa_rodzaj-zdjecia');
            }
        }, 0);
    }

    initSmoothScroll () {
        $('a[href*="#"]').not('[href="#"]').not('[href="#0"]').click(function(event) {
            if (
                location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
                &&
                location.hostname == this.hostname
            ) {
                var target = $(this.hash);
                target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
                if (target.length) {
                    event.preventDefault();
                    $('html, body').animate({
                        scrollTop: target.offset().top - 200
                    }, 1000);
                }
            }
        });
    }

    initProductDemo () {
        if (!$('.product-demo-wrapper').length) {
            return;
        }

        if ($('.product-demo-select-photo').length) {
            $('.product-demo-select-photo').on('click', e => {
                e.preventDefault();
                $('#custom-photo-popup').removeClass('is-hidden');
            });
        }

        if ($('#pa_rozmiar').length) {
            this.setDemoAreaSize();

            $('#pa_rozmiar').on('change', () => {
                this.setDemoAreaSize();
            });
        }

        if ($('#pa_rodzaj-zdjecia').length) {
            this.setDemoColor();

            $('#pa_rodzaj-zdjecia').on('change', () => {
                this.setDemoColor();
            });
        }

        let photoIdInUrl = this.getPhotoIdFromUrl();

        if (photoIdInUrl) {
            let endpoint = $('#main').attr('data-photo-url-endpoint');

            $.get(endpoint + photoIdInUrl).done(response => {
                if (response && response.url) {
                    this.setPhoto(photoIdInUrl, response.url);
                }
            });
        }
    }

    getPhotoIdFromUrl () {
        let queryString = window.location.search.replace('?', '');

        if (!queryString) {
            return false;
        }

        queryString = queryString.split('&').map(keypair => keypair.split('='));
        queryString = queryString.filter(keypair => keypair[0] === 'photo-id');

        if (!queryString.length) {
            return false;
        }

        return parseInt(queryString[0][1], 10);
    }

    setPhoto (id, url) {
        $('#pawaug-custom-photo-id').val(parseInt(id, 10));
        $('.product-demo-select-photo').addClass('has-bg');
        $('.product-demo-selected-photo').css('background-image', 'url(' + url + ')');
        $('#custom-photo-popup').addClass('is-hidden');
        $('#pawaug-custom-photo-id').removeClass('is-empty');
    }

    setDemoAreaSize () {
        let currentSize = $('#pa_rozmiar').val();
        currentSize = currentSize.split('-');
        let sizeWidth = parseInt(currentSize[0], 10);
        let sizeHeight = parseInt(currentSize[2], 10);
        $('.product-demo-select-photo').css('height', 'calc(' + (sizeHeight * 0.5 * 0.8) + '% + 90px)');
        $('.product-demo-select-photo').css('width', 'calc(' + (sizeWidth * 0.3387 * 0.8) + '% + 90px)');

        if (sizeWidth < 30 || sizeHeight < 30) {
            $('.product-demo-select-photo').addClass('is-small');
        } else {
            $('.product-demo-select-photo').removeClass('is-small');
        }
    }

    setDemoColor () {
        let currentColor = $('#pa_rodzaj-zdjecia').val();

        if (currentColor === 'kolorowe') {
            $('.product-demo-select-photo').removeClass('is-black-white');
        } else if (currentColor === 'czarno-biale') {
            $('.product-demo-select-photo').addClass('is-black-white');
        }
    }

    initCustomPhotoPopup () {
        if (!$('#custom-photo-popup').length) {
            return;
        }

        $('.custom-photo-popup-close').on('click', e => {
            e.preventDefault();
            $('#custom-photo-popup').addClass('is-hidden');
        });

        let createAndApplyTexture = null;

        if ($('#pawaug-3d-demo').length) {
            modelViewer = $('#pawaug-3d-demo')[0];
            modelViewer.addEventListener("load", () => {
                modelViewer.classList.remove('is-loading');
                this.setMaterialIndex();
                let material = modelViewer.model.materials[this.materialIndex];
                createAndApplyTexture = async (channel, imageUrl) => {   
                    imageUrl = imageUrl.replace(/\-[0-9]{1,5}x[0-9]{1,5}/gmi, '');
                    
                    this.resizeTexture(imageUrl).then(async (dataUri) => {
                        let texture = await modelViewer.createTexture(dataUri, 'image/jpeg');
                        material.pbrMetallicRoughness[channel].setTexture(texture);
                    }).catch(error => {
                        console.log('Wystąpił błąd: ' + error);
                    });
                };

                let photoIdInUrl = this.getPhotoIdFromUrl();

                if (photoIdInUrl) {
                    let endpoint = $('#main').attr('data-photo-url-endpoint');

                    $.get(endpoint + photoIdInUrl).done(response => {
                        if (response && response.url) {
                            this.texturePath = response.url;
                            $('#select-photo-for-model').text('Zmień zdjęcie');
                            createAndApplyTexture('baseColorTexture', response.url);
                        }
                    });
                }
            }, { 
                once: true 
            });

            $('#pa_rozmiar').on('input', () => {
                modelViewer.classList.add('is-loading');
                let modelSizeToLoad = $('#pa_rozmiar').val();
                let productID = window.pawAug3DModels.productID;
                let modelToLoad = window.pawAug3DModels.models[productID][modelSizeToLoad];
                let modelSize = modelSizeToLoad.replace('-x-', '|').replace('-cm', ''); 
                let previousModel = modelViewer.getAttribute('src');
                this.textureRatioW = parseInt(modelSize.split('|')[0], 10);
                this.textureRatioH = parseInt(modelSize.split('|')[1], 10);
                this.setMaterialIndex();

                if ($('#select-photo-switch-frame').length && $('#select-photo-switch-frame').attr('data-status') === 'dark') {
                    modelToLoad = modelToLoad.replace('.glb', '_dark.glb');
                }

                if (previousModel === modelToLoad) {
                    let material = modelViewer.model.materials[this.materialIndex];
                    createAndApplyTexture = async (channel, imageUrl) => {   
                        imageUrl = imageUrl.replace(/\-[0-9]{1,5}x[0-9]{1,5}/gmi, '');
                        
                        this.resizeTexture(imageUrl).then(async (dataUri) => {
                            let texture = await modelViewer.createTexture(dataUri, 'image/jpeg');
                            material.pbrMetallicRoughness[channel].setTexture(texture);
                        }).catch(error => {
                            console.log('Wystąpił błąd: ' + error);
                        });
                    };

                    createAndApplyTexture('baseColorTexture', this.texturePath);
                    modelViewer.classList.remove('is-loading');
                } else {   
                    modelViewer.addEventListener("load", () => {
                        modelViewer.classList.remove('is-loading');
                        let material = modelViewer.model.materials[this.materialIndex];
                        createAndApplyTexture = async (channel, imageUrl) => {   
                            imageUrl = imageUrl.replace(/\-[0-9]{1,5}x[0-9]{1,5}/gmi, '');
                            
                            this.resizeTexture(imageUrl).then(async (dataUri) => {
                                let texture = await modelViewer.createTexture(dataUri, 'image/jpeg');
                                material.pbrMetallicRoughness[channel].setTexture(texture);
                            }).catch(error => {
                                console.log('Wystąpił błąd: ' + error);
                            });
                        };

                        createAndApplyTexture('baseColorTexture', this.texturePath);
                    }, { 
                        once: true 
                    });

                    modelViewer.setAttribute('src', modelToLoad);
                }
            });

            $('#pa_rozmiar').trigger('input');
        }

        $('.custom-photo-popup-content').on('click', e => {
            if (e.target.tagName === 'A' && e.target.getAttribute('href') === '#select-photo') {
                $('#pawaug-custom-photo-id').val(parseInt(e.target.getAttribute('data-photo-id'), 10));
                $('.product-demo-select-photo').addClass('has-bg');
                $('.product-demo-selected-photo').css('background-image', 'url(' + e.target.getAttribute('data-photo-url') + ')');
                $('#custom-photo-popup').addClass('is-hidden');
                $('#pawaug-custom-photo-id').removeClass('is-empty');

                if ($('#pawaug-3d-demo').length && createAndApplyTexture) {
                    this.texturePath = e.target.getAttribute('data-photo-url');
                    $('#select-photo-for-model').text('Zmień zdjęcie');
                    createAndApplyTexture('baseColorTexture', e.target.getAttribute('data-photo-url'));
                }
            }
        });

        let tabs = $('#custom-photo-popup .custom-photo-popup-categories > li');
        let tabsContent = $('#custom-photo-popup .custom-photo-popup-category-photos');

        for (let i = 0; i < tabs.length; i++) {
            tabs.eq(i).on('click', e => {
                e.preventDefault();
                tabs.removeClass('is-active');
                tabs.eq(i).addClass('is-active');
                tabsContent.removeClass('is-active');
                tabsContent.eq(i).addClass('is-active');
            });
        }
    }

    initCustomProductPopup () {
        if (!$('#custom-product-popup').length) {
            return;
        }

        $('.custom-product-popup-close').on('click', e => {
            e.preventDefault();
            $('#custom-product-popup').addClass('is-hidden');
        });
    }

    initAddToCartButtonsForPhotos () {
        if (!$('body').hasClass('page-template-default')) {
            return;
        }

        if ($('#main').attr('data-disabled-add-to-cart') === 'true') {
            return;
        }

        let photosToBuy = $('.wp-block-gallery.is-style-mosaic > figure > a');

        for (let i = 0; i < photosToBuy.length; i++) {
            let img = photosToBuy.eq(i).find('img');

            if (img.length) {
                let id = img.attr('data-id');

                if (id) {
                    id = parseInt(id, 10);
                    let btn = $('<a href="" class="pawaug-photo-to-buy-btn">Zamów to zdjęcie</a>');
                    btn.attr('href', '#' + id);
                    btn.appendTo(photosToBuy.eq(i).parent());
                    btn.on('click', e => {
                        e.preventDefault();
                        e.stopPropagation();
                        let popup = $('#custom-product-popup');
                        let linksToSet = popup.find('.custom-photo-popup-product-link');
                        
                        for (let j = 0; j < linksToSet.length; j++) {
                            let oldLink = linksToSet.eq(j).attr('href');
                            let newLink = oldLink.split('?')[0] + '?photo-id=' + id;
                            linksToSet.eq(j).attr('href', newLink);
                        }

                        popup.removeClass('is-hidden');
                    });
                }
            }
        }
    }

    initNewestInfoBlock () {
        let currentBlock = $('.pawaug-newest-info');
        let status = Cookies.get('pawaug-newest-info');

        if (!currentBlock.length) {
            return;
        }

        let currentBlockID = currentBlock.attr('data-id');
        currentBlockID = currentBlockID.replace(/[^a-z0-9\-\_]/gmi, '');
        
        if (status !== currentBlockID) {
            setTimeout(() => {
                currentBlock.removeClass('is-hidden');

                currentBlock.find('.pawaug-newest-info-close').on('click', e => {
                    e.preventDefault();
                    currentBlock.addClass('is-hidden');
                    Cookies.set('pawaug-newest-info', currentBlockID, { expires: 30 });

                    setTimeout(() => {
                        currentBlock.remove();
                    }, 500);
                });

                currentBlock.find('a').each((i, link) => {
                    let linkItem = $(link);
                    linkItem.on('click', e => {
                        e.preventDefault();
                        Cookies.set('pawaug-newest-info', currentBlockID, { expires: 30 });
                        currentBlock.addClass('is-hidden');
                        setTimeout(() => {
                            window.location.href = linkItem.attr('href');
                        }, 100);
                    });
                });
            }, 3000);
        } else {
            currentBlock.remove();
        }
    }

    init3dViewer () {
        if ($('#select-photo-for-model').length) {
            $('#select-photo-for-model').on('click', e => {
                e.preventDefault();
                $('#custom-photo-popup').removeClass('is-hidden');
            });

            if ($('.custom-photo-message').length) {
                $('.custom-photo-message a').on('click', e => {
                    e.preventDefault();
                    $('#custom-photo-popup').removeClass('is-hidden');
                });
            }
        }

        if ($('#pa_rodzaj-zdjecia').length) {
            $('#pa_rodzaj-zdjecia').on('input', () => {
                $('#pa_rozmiar').trigger('input');
            });
        }

        if ($('#select-photo-switch-frame').length) {
            $('#select-photo-switch-frame').on('click', e => {
                e.preventDefault();

                if ($('#select-photo-switch-frame').attr('data-status') === 'light') {
                    $('#select-photo-switch-frame').attr('data-status', 'dark');
                    $('#select-photo-switch-frame').text($('#select-photo-switch-frame').attr('data-text-light'));
                } else {
                    $('#select-photo-switch-frame').attr('data-status', 'light');
                    $('#select-photo-switch-frame').text($('#select-photo-switch-frame').attr('data-text-dark'));
                }

                $('#pa_rozmiar').trigger('input');
            });
        }
    }

    resizeTexture (url) {
        return new Promise((resolve, reject) => {
            let img = new Image();

            img.onload = () => {
                let targetRatio = [this.textureRatioW, this.textureRatioH];
                let { width, height } = img;
                let currentRatio = width / height;
                let newWidth, newHeight, offsetX, offsetY;

                if (currentRatio > targetRatio[0] / targetRatio[1]) {
                    newWidth = height * (targetRatio[0] / targetRatio[1]);
                    offsetX = (width - newWidth) / 2;
                    newHeight = height;
                    offsetY = 0;
                } else {
                    newWidth = width;
                    offsetX = 0;
                    newHeight = width * (targetRatio[1] / targetRatio[0]);
                    offsetY = (height - newHeight) / 2;
                }

                let canvas = document.createElement("canvas");
                canvas.width = newWidth;
                canvas.height = newHeight;
                let ctx = canvas.getContext("2d");
                ctx.drawImage(img, offsetX, offsetY, newWidth, newHeight, 0, 0, newWidth, newHeight);

                if($('#pa_rodzaj-zdjecia').val() === 'czarno-biale') {
                    let imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
                    let data = imageData.data;

                    for (let i = 0; i < data.length; i += 4) {
                        let avg = (data[i] + data[i + 1] + data[i + 2]) / 3;
                        data[i]     = avg; // red
                        data[i + 1] = avg; // green
                        data[i + 2] = avg; // blue
                    }

                    ctx.putImageData(imageData, 0, 0);
                }

                resolve(canvas.toDataURL("image/jpeg"));
            };

            img.onerror = () => {
                reject(new Error('Nie można załadować obrazka.'));
            };

            img.src = url;
        });
    }

    setMaterialIndex () {
        this.materialIndex = 0;

        if (window.pawAug3DModels.material === 'pianka' || window.pawAug3DModels.material === 'pcv') {
            this.materialIndex = 1;
        } else if (window.pawAug3DModels.material === 'plotno') {
            if (this.textureRatioW === 105) {
                this.materialIndex = 1;
            } else {
                this.materialIndex = 5;
            }
        } else if (window.pawAug3DModels.material === 'papier') {
            if (this.textureRatioW === 50 && this.textureRatioH === 35) {
                this.materialIndex = 2;
            } else if (this.textureRatioW === 30 && this.textureRatioH === 21) {
                this.materialIndex = 3;
            } else if (this.textureRatioW === 40 && this.textureRatioH === 30) {
                this.materialIndex = 0;
            } else if (this.textureRatioW === 50 && this.textureRatioH === 35) {
                this.materialIndex = 3;
            } else if (this.textureRatioW === 50 && this.textureRatioH === 40) {
                this.materialIndex = 1;
            } else if (this.textureRatioW === 70 && this.textureRatioH === 50) {
                this.materialIndex = 2;
            } else if (this.textureRatioW === 100 && this.textureRatioH === 70) {
                this.materialIndex = 0;
            }
        }
    }

    createStylizedOptionSelector (selectId) {
        let selectElement = document.getElementById(selectId);
        
        if (!selectElement) {
            return;
        }

        if (selectId === 'pa_rozmiar') {
            selectElement.parentNode.parentNode.querySelector('.label label').innerText = 'Rozmiar (w cm)';
        }
    
        selectElement.style.display = 'none';
    
        let selectorWrapper = document.createElement('div');
        selectorWrapper.className = 'js-option-selector-wrapper';
        let selectorContainer = document.createElement('div');
        selectorContainer.className = 'js-option-selector';
    
        selectElement.querySelectorAll('option').forEach(option => {
            if (!option.value) {
                return;
            }

            let optionDiv = document.createElement('div');
            optionDiv.className = 'js-option-selector-item';
            optionDiv.setAttribute('data-value', option.value);
            optionDiv.textContent = option.textContent.replace(' x ', '×').replace(' cm', '');
        
            optionDiv.addEventListener('click', function() {
                selectorContainer.querySelectorAll('.js-option-selector-item').forEach(item => {
                    item.classList.remove('is-selected');
                });
        
                this.classList.add('is-selected');
                selectElement.value = this.getAttribute('data-value');
                selectElement.dispatchEvent(new Event('input'));
                $(selectElement).change();
            }, false);
        
            selectorContainer.appendChild(optionDiv);
        });
    
        selectorWrapper.appendChild(selectorContainer);
        selectElement.after(selectorWrapper);
        let selectedValue = selectElement.value;
        let selectedOptionDiv = selectorContainer.querySelector(`.js-option-selector-item[data-value="${selectedValue}"]`);
        
        if (selectedOptionDiv) {
            selectedOptionDiv.classList.add('is-selected');
        }
    }
}
